import React, { useState } from "react";
// react-swipeable-views
import SwipeableViews from "react-swipeable-views";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import styles from "./tabListStyle";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(styles);

export default function TabList(props) {
  const { tabList } = props;
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  return (
    <div className={classes.tabListContainer}>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={5}>
          <SwipeableViews
            index={value}
            onChangeIndex={handleChangeIndex}
            hysteresis={0.1}
            enableMouseEvents={true}
            resistance={true}
          >
            {tabList.map((item, index) => {
              return (
                <TabPanel
                  value={value}
                  index={index}
                  className={classes.tabImg}
                  key={index}
                >
                  <img
                    src={item.tab_img}
                    alt={item.tab_name}
                    className={classes.profieImg}
                  />
                </TabPanel>
              );
            })}
          </SwipeableViews>
        </Grid>
        <Grid item xs={12} sm={7} className={classes.detailContainer}>
          <AppBar
            position="relative"
            color="default"
            className={classes.tabBar}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className={classes.tabs}
            >
              {tabList.map((item, index) => {
                return <Tab label={item.tab_name} key={index} />;
              })}
            </Tabs>
          </AppBar>
          <SwipeableViews
            index={value}
            onChangeIndex={handleChangeIndex}
            className={classes.swipeView}
            hysteresis={0.1}
            enableMouseEvents={true}
            resistance={true}
          >
            {tabList.map((item, index) => {
              return (
                <TabPanel
                  value={value}
                  index={index}
                  className={classes.tabPanel}
                  key={index}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.tab_text,
                    }}
                  ></div>
                </TabPanel>
              );
            })}
          </SwipeableViews>
        </Grid>
      </Grid>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}
